import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _class, _AbOverlay;
/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED -- ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { BaseRCmp } from "abreact/incubator/ui/component/BaseRCmp";
import { observer } from "mobx-react";
import * as React from "react";

/**
 * The properties that can be provided when constructing an overlay.
 */

/**
 * A full screen element that can be used to mask elements beneath a popup.
 */
export let AbOverlay = observer(_class = (_AbOverlay = class AbOverlay extends BaseRCmp {
  constructor(props, context) {
    super(props, context);
    _defineProperty(this, "key", void 0);
    this.key = `ab-overlay${AbOverlay.NEXT_KEY++}`;
  }
  render() {
    //<stringsAreClassNames>
    const classes = ["ab-overlay", this.props.className, this.props.transparent ? "" : "visible", this.props.popupCentered ? "centered" : ""].join(" ").trim();
    //</stringsAreClassNames>

    return /*#__PURE__*/React.createElement("div", {
      key: this.key,
      className: classes,
      style: {
        ...this.props.style
      },
      onClick: this.props.onClick
    }, this.props.children);
  }
}, _defineProperty(_AbOverlay, "NEXT_KEY", 1), _AbOverlay)) || _class;
//# sourceMappingURL=AbOverlay.js.map
